// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"d3fbe1e2","361":"61829ebf","511":"c14f86ef","767":"3f5f5ab2"}[chunkId] + ".chunk.js";
};